import React from 'react';
import StatCard from '../../../../Components/StatCard/StatCard';

function SaleStats() {
    return (
        <div className="grid grid-cols-3 gap-x-3 mx-5 mt-4">
            <StatCard 
                statName="Total Sales"
                statValue={0}
            />
            <StatCard 
                statName="Total Orders"
                statValue={0}
            />
            <StatCard 
                statName="Conversion Rates"
                statValue={0} 
                hasPercent={true} 
            />
        </div>
    )
}

export default SaleStats;
